"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgUniversalAccess = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16zm4.955 5.421c.192.56.02.97-.519 1.23l-2.449.687v2.757c0 .288.247 1.547.74 3.778.101.573-.146.944-.74 1.113-.594.17-1.002-.091-1.224-.782l-.775-4.197-.78 4.197c-.16.635-.55.896-1.171.782-.62-.113-.885-.483-.792-1.11.496-2.225.744-3.486.744-3.78a53.09 53.09 0 000-2.725l-2.29-.612c-.65-.201-.886-.61-.709-1.225.177-.616.586-.852 1.225-.708l1.765.472a7.78 7.78 0 002.008.234 7.73 7.73 0 002-.26l1.815-.49c.575-.134.959.08 1.152.64zM12 5a2 2 0 110 4 2 2 0 010-4z' }))); };
exports.default = SvgUniversalAccess;
//# sourceMappingURL=UniversalAccess.js.map